import React, {useState} from 'react'
import _ from 'lodash'
import {IconButton, Checkbox} from '@material-ui/core'
import CircleCheckedFilled from '@material-ui/icons/CheckCircle'
import CreateIcon from '@material-ui/icons/Create'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import CheckIcon from '@material-ui/icons/Check'

// custom components
import FilteredViewItem from '../FilteredViewItem'

const GroupViewItem = ({
  data,
  groups,
  selectedView,
  selectedFilteredView,
  onClickView,
  onClickFilteredView,
  onClickEdit,
  onClickEditFilteredView,
}) => {
  const [expand, setExpand] = useState(true)

  const name = groups.data.find(d => d.id === data.group_view.entity_id)?.name || 'loading...'
  // change to white if has selectedFilteredView
  const mcolor = _.isEmpty(selectedFilteredView) ? data.group_view.color : '#ffffff'

  return (
    <div>
      <div>
        <div className="c-calendar-views__item ap-flex--align-center">
          <Checkbox
            size={'small'}
            checkedIcon={
              <div
                style={{
                  height: 16,
                  width: 16,
                  margin: 2,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  // borderRadius: '50%',
                  // background: mcolor,
                }}
              >
                <CheckIcon style={{fontSize: 15, color: '#303A52'}} />
              </div>
            }
            checked={selectedView?.group_view?.entity_id === data.group_view.entity_id}
            onClick={ev => onClickView(ev, data)}
            value={data}
            disabled={name === 'loading...'}
          />
          <span
            className="ap-typography ap-typography--sm ap-ellipsis cursor_pointer"
            title={name}
            onClick={ev => onClickView(ev, data)}
          >
            {name}
          </span>
          <div className="ap-flex ap-flex--end">
            <IconButton
              size="small"
              className="ap-icon-button ap-icon-button--square btn-hover btn-hover--hidden"
              onClick={ev => onClickEdit(data.group_view)}
              style={{marginRight: 4}}
            >
              <CreateIcon style={{transform: 'scale(.60)'}} />
            </IconButton>
            <IconButton
              size="small"
              className="ap-icon-button ap-icon-button--square btn-hover"
              onClick={() => setExpand(p => !p)}
              style={{marginLeft: 4}}
            >
              {!_.isEmpty(data.group_view.calendar_child_view) &&
                (expand ? <ExpandMoreIcon /> : <ChevronLeftIcon />)}
            </IconButton>
          </div>
        </div>
        <div hidden={!expand}>
          {_.map(data.group_view.calendar_child_view, (c, i) => (
            <FilteredViewItem
              key={i}
              data={c}
              selectedFilteredView={selectedFilteredView}
              onClick={(e, v) => onClickFilteredView(e, v, data)}
              onClickEdit={onClickEditFilteredView}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default GroupViewItem
